<template>
    <v-container>
        <v-alert
            type="warning"
        >
            Logging you out...
        </v-alert>
    </v-container>
</template>

<script>
import axios from "axios"

export default {
    name: 'logout',
    metaInfo: {
        title: 'Digital Tuguegarao - Logout'
    },
    data() {
        return {

        }
    },
    methods: {
        redirect() {
            this.$session.destroy()

            this.$ls.remove('isLoggedIn')

            localStorage.removeItem('app-xstate')
            localStorage.removeItem('crm_entryauth')
            localStorage.removeItem('crm_global_details')

            // window.location.href = decodeURIComponent(this.$route.query.redirect)
            window.location.href = `https://egov.tuguegaraocity.gov.ph:3000/logmeout?redirect=${decodeURIComponent(this.$route.query.redirect)}`
        },
        logout() {
            this.$session.start()
            const authid = this.$session.get('crmusersessionauthid')

            // console.log(authid)

            axios({
                method: 'post',
                url: `${this.domain}/crm_log_me_out`,
                data: {
                    authid,
                }
            })
                .then(() => {
                    // console.log(response)

                    this.redirect()
                })
                .then(() => {
                    // window.location.href = decodeURIComponent(this.$route.query.redirect)
                    this.redirect()
                })
        }
    },
    mounted() {
        this.logout()
    }
}
</script>